import React from 'react';
import { IconProps } from './IconTypes';

const RAY_COUNT = 8;
const rayIndices = Array.from({ length: RAY_COUNT }, (_, i) => i);

const HelionLogo: React.FC<IconProps> = ({
  size = 16,
  color = "currentColor",
  className = "",
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill={color}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="50" cy="50" r="20" />
      {rayIndices.map(i => {
        const angle = (i * (360 / RAY_COUNT)) * Math.PI / 180;
        const x1 = 50 + 28 * Math.cos(angle);
        const y1 = 50 + 28 * Math.sin(angle);
        const x2 = 50 + 44 * Math.cos(angle);
        const y2 = 50 + 44 * Math.sin(angle);
        const px = -Math.sin(angle) * 4;
        const py = Math.cos(angle) * 4;
        return (
          <polygon
            key={i}
            points={`${x1 + px},${y1 + py} ${x1 - px},${y1 - py} ${x2 - px / 3},${y2 - py / 3} ${x2 + px / 3},${y2 + py / 3}`}
          />
        );
      })}
    </svg>
  );
};

export default HelionLogo;
